
import {vsprintf} from 'sprintf-js';
import {LocaleStore} from './services/Locale';

/**
 * Emnty implementation of translation function.
 * On the future we overload this function in order to have automatic translation.
 * Currently this function works like C sprintf() function.
 * @returns {*}
 */
function t() {
    if (arguments.length === 0) return "";
    let text = LocaleStore.trans(arguments[0]);
    if (arguments.length > 1) return vsprintf(text, Array.prototype.slice.call(arguments, 1));
    return text;
}

/**
 * Returns string value.
 * @param value Value, can be undefined or null.
 * @returns {string}
 */
function formatString(value) {
    if (value == null) return '';
    return value.toString();
}

function formatCurrency(value, currencyCode) {
    return LocaleStore.formatCurrency(value, currencyCode);
}

function formatDecimal(value) {
    return LocaleStore.formatDecimal(value);
}

function formatInteger(value) {
    if (value == null || isNaN(value)) return "";
    return value.toString();
}

function formatDate(value) {
    return LocaleStore.formatDate(value);
}

function formatDateTime(value) {
    return LocaleStore.formatDateTime(value);
}

function formatTime(value) {
    return LocaleStore.formatTime(value);
}

/**
 * Returns relative time from now.
 * @param value Date object specifying from date and time
 * @param value2 Date object specifying to date and time. If missing then current date and time will be used.
 * @returns {*} Relative time as string
 */
function formatElapsedTime(value, value2) {
    return LocaleStore.formatElapsedTime(value, value2);
}

function formatBoolean(value) {
    if (value == null) return "";
    if (value) return t("true");
    return t("false");
}

function formatYesNo(value) {
    if (value == null) return "";
    if (value) return t("yes");
    return t("no");
}

export {
    t as default,
    t,
    formatCurrency,
    formatDate,
    formatDateTime,
    formatTime,
    formatInteger,
    formatDecimal,
    formatString,
    formatElapsedTime,
    formatBoolean,
    formatYesNo
};
